export default __webpack_public_path__ + "static/media/volume-low.b099d234.svg";